import Vue from 'vue'
import App from './App.vue'
import store from './store'

Vue.config.productionTip = false

const containers = document.querySelectorAll('[data-vue]')

containers.forEach(container => {
  new Vue({
    store,

    render: h => {
      const context = {
        props: { ...container.dataset }
      }
      return h(App, context)
    }
  }).$mount(container)
})
